import React, { useEffect, useRef } from "react";

import { withRouter, RouteComponentProps } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";

import { ErrorBoundary } from "@sentry/react";
import { useContext, useMemo } from "react";
import { RootStateOrAny, useSelector } from "react-redux";
import { ErrorMsg, NoDataMsg } from "../../../../components/AppMessages";
import LoadingEllipsis from "../../../../components/Loading/LoadingEllipsis";
import { ThemeContext } from "../../../../context";
import { getBrandKPITrend } from "../../../../api/brandPerformanceApi";
import BrandKPITrendChart from "../../../../components/Charts/BrandPerformance/BrandKPITrend";
import { MetricType } from "./BrandKPIContent";

interface Props extends RouteComponentProps {
  trendTitle: string;
  percentageChart?: boolean;
  diff: number;
  nissanCompetitor: string;
  metric: string;
  maximumScoreRange: number;
  granularity: string;
  data: any;
  loadingBrandKPITrendData: boolean;
  series: any;
  chartTitles: MetricType[];
}

const BrandKPITrend = withRouter((props: Props) => {
  const { theme } = useContext(ThemeContext);
  const params = useSelector((state: RootStateOrAny) => state.parameters);

  const { granularityParam, market } = params;
  const {
    diff,
    nissanCompetitor,
    metric,
    history,
    percentageChart,
    maximumScoreRange,
    granularity,
    data,
    loadingBrandKPITrendData,
    series,
    chartTitles,
  } = props;

  const topModels = useMemo(() => {
    return series?.slice(-10)?.map((series: { name: any }) => series?.name);
  }, [data]);

  return (
    <div>
      <div className="kpi-trend-metric-title">{metric}</div>
      {data?.length && !loadingBrandKPITrendData ? (
        <ErrorBoundary fallback={<ErrorMsg />}>
          <BrandKPITrendChart
            theme={theme}
            chartId={metric}
            granularity={granularity ? granularity : granularityParam}
            seriesList={series}
            data={data}
            percentageChart={percentageChart}
            nissanCompetitor={nissanCompetitor}
            market={market}
            diff={diff}
            metric={metric}
            maximumScoreRange={maximumScoreRange}
            chartTitles={chartTitles}
          />
        </ErrorBoundary>
      ) : loadingBrandKPITrendData ? (
        <LoadingEllipsis isLoading={true} />
      ) : (
        <NoDataMsg message="No data available" />
      )}{" "}
    </div>
  );
});

export default BrandKPITrend;
